import React, { Component } from "react";
import styles from "./Header.module.scss";
import classnames from "classnames";

const I18N = {
  en: {
    viewAll: "View all",
  },
  fr: {
    viewAll: "Voir tout",
  },
  nl: {
    viewAll: "Bekijk alles",
  },
};

export default class Communities extends Component {
  renderCommunities() {
    const { communities, app, onSelectCommunity } = this.props;
    const { appUrl } = app;

    if (!communities || communities.length === 0) {
      return null;
    }

    let clientsBlock = [];

    for (let i = 0; i < communities.length; i++) {
      let logo = communities[i].organizations[0].avatarUrl
        ? `${communities[i].organizations[0].avatarUrl}`
        : "img/default-logo.png";
      let logoBlock = (
        <span
          className={styles.boxes__box__logo}
          style={{ backgroundImage: `url(${logo})` }}
        ></span>
      );
      let clientName = communities[i].organizations[0].name;
      if (communities[i].organizations[0].abbreviation) {
        clientName = communities[i].organizations[0].abbreviation;
      } else if (clientName.length > 30) {
        clientName = clientName.substr(0, 30) + "...";
      }

      let organizations = [];
      if (
        communities[i].organizations &&
        communities[i].organizations.length > 1
      ) {
        for (let j = 0; j < communities[i].organizations.length; j++) {
          organizations.push(
            <li
              key={`client-${i}-${j}-${communities[i].organizations[j].id}`}
              onClick={(e) => {
                onSelectCommunity(communities[i].organizations[j]);
                e.stopPropagation();
              }}
            >
              <a href="#" onClick={(event) => event.preventDefault()}>
                {communities[i].organizations[j].abbreviation}
              </a>
            </li>
          );
        }
      }

      if (onSelectCommunity) {
        clientsBlock.push(
          <li
            className={styles.menu__subChild}
            key={`client-${communities[i].organization.id}`}
            onClick={() => onSelectCommunity(communities[i].organizations[0])}
          >
            <a href="javascript:void(0);">
              {logoBlock}
              {clientName}
            </a>
            {organizations.length > 1 ? <ul>{organizations}</ul> : ""}
          </li>
        );
      }
    }

    return (
      <div className={styles.menu__dropdown}>
        <ul>{clientsBlock}</ul>
      </div>
    );
  }

  render() {
    const { currentCommunity, communities } = this.props;

    if (!communities || communities.length === 0) {
      return null;
    }

    let navText = "Communities";

    if (currentCommunity) {
      navText =
        currentCommunity.abbreviation ||
        (currentCommunity.name.length <= 20
          ? currentCommunity.name
          : currentCommunity.name.substring(0, 20));
    }

    return (
      <div
        className={classnames(styles.menu__hasChild, styles.menu__community)}
      >
        <div className={`${styles.menu__link}`} style={{ cursor: "pointer" }}>
          <span>{navText}</span>
          <i className="icon-ttp-chevron-down"></i>
        </div>
        {this.renderCommunities()}
      </div>
    );
  }
}
